{
  "button_label": "Texts",
  "tease": {
    "title": "Text reminders",
    "body": "Automatically text your family before this event. Part of the Family plan — click to upgrade."
  },
  "move": {
    "title": "Move to send text reminders",
    "body": "Text reminders send from your family workspace. Move this planner to {{name}} to schedule them.",
    "destination_label": "Move to",
    "irreversible": "This planner and its pages leave your personal workspace. This can't be undone, and you won't be able to move it back.",
    "confirm": "Move planner",
    "cancel": "Cancel",
    "title_member": "Text reminders",
    "body_member": "Text reminders send from a family workspace. This planner is in a personal one, so only its owner can move it.",
    "dismiss": "Got it"
  },
  "panel": {
    "header": "Text messages",
    "event_in_past_text": "No messages can be added to this event because it's in the past",
    "empty_state": {
      "body": "Text reminders are a great way to keep your family in the loop!",
      "call_to_action": "Add text"
    },
    "add_another_message": "Add another message",
    "error_deleting_message_toast": "Error deleting message",
    "error_saving_event_toast": "Error saving event",
    "reached_message_limit_tooltip": "You've scheduled the maximum number of messages for this event, please delete a message to schedule another",
    "reached_message_limit_instance_tooltip": "You've scheduled the maximum number of messages for this date, please delete a message to schedule another",
    "plan_inactive_text": "Your Family plan isn't active, so no new reminders can be scheduled. These are still here, and they'll send again once the plan is back.",
    "plan_inactive_empty_text": "Your Family plan isn't active, so text reminders can't be scheduled right now."
  },
  "form": {
    "applies_to": "For the event starting on {{date}}",
    "applies_to_instance": "For the {{date}} instance of this repeating event",
    "pending_schedule_edit_tooltip": "Save your changes to the event's date or repeat schedule before editing text messages",
    "when": {
      "label": "When should the message go out?",
      "minutes_before": "Minutes before",
      "minutes_after": "Minutes after",
      "hours_before": "Hours before",
      "hours_after": "Hours after",
      "day_of": "Day of",
      "day_before": "Day before",
      "day_after": "Day after"
    },
    "who": {
      "label": "Who should receive the message?",
      "no_recipients": "Add phone numbers for your family members in your organization settings to start sending text reminders.",
      "no_recipients_member": "Ask the owner of {{name}} to add phone numbers before text reminders can be sent.",
      "manage_members": "Manage {{name}} members"
    },
    "what": {
      "label": "What should the message say?",
      "ai_title": "Write with AI",
      "ai_disabled_tooltip": "Add a title to your event to write a message with AI",
      "ai_error_toast": "Error suggesting a text message"
    },
    "errors": {
      "min_minutes_value": "Minimum value is 15 minutes",
      "gt_zero": "Value must be greater than 0",
      "time_required": "Enter a time",
      "message_required": "Message is required"
    },
    "actions": {
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "delete_confirm": "Confirm"
    },
    "no_recipients_tooltip": "Add family phone numbers in your organization settings to send text reminders",
    "no_recipients_tooltip_member": "The owner of {{name}} can add family phone numbers to send text reminders"
  },
  "select": {
    "everyone": "Everyone"
  },
  "bubble": {
    "everyone": "Everyone",
    "unknown_member": "Unknown",
    "edit_message": "Edit message",
    "delete_message": "Delete message",
    "delete_confirm": "Confirm delete",
    "delete_cancel": "Cancel"
  }
}
